"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var client_lib_js_player_addons_common_player_1 = require("@sky-uk-ott/client-lib-js-player-addons-common-player");
var client_lib_js_player_lib_webos_1 = require("@sky-uk-ott/client-lib-js-player-lib-webos");
var webos_lifecycle_1 = require("./webos-lifecycle");
var webos_player_1 = require("./webos-player");
var webos_drm_1 = require("./webos-drm");
var webos_input_1 = require("./webos-input");
var webos_info_1 = require("./webos-info");
var webos_capabilities_1 = require("./webos-capabilities");
var webos_network_status_1 = require("./webos-network-status");
var WebOSDeviceFactory = (function () {
    function WebOSDeviceFactory(appId, startingBitrate, context) {
        if (context === void 0) { context = window; }
        this.appId = appId;
        this.startingBitrate = startingBitrate;
        this.context = context;
        this.initialised = false;
        if (!this.appId || !this.startingBitrate) {
            throw new Error('WebOSDeviceFactory constructor missing args. Needs AppID(string) and Starting Bitrate(number)');
        }
    }
    WebOSDeviceFactory.prototype.identifiers = function () {
        return [client_lib_js_player_addons_common_player_1.DeviceType.WebOS];
    };
    WebOSDeviceFactory.prototype.getInstance = function () {
        if (!this.initialised) {
            throw new Error('WebOS Device Factory was not initialised');
        }
        return this.device;
    };
    WebOSDeviceFactory.prototype.initialise = function () {
        return __awaiter(this, void 0, void 0, function () {
            var drmAgent, input, storage, lifecycle, deviceInfo, capabilities, networkStatus, player;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.context.webOS) {
                            client_lib_js_player_lib_webos_1.initialiseWebOS();
                        }
                        drmAgent = new webos_drm_1.WebOSDRMAgent(this.context, this.appId, function (e) { return _this.device.player.notifyError(e); });
                        input = new webos_input_1.WebOSInput(this.context);
                        storage = new client_lib_js_player_addons_common_player_1.HTML5LocalStorage(this.context);
                        lifecycle = new webos_lifecycle_1.WebOSLifecycle(this.context);
                        deviceInfo = new webos_info_1.WebOSInfo(storage, this.context);
                        capabilities = new webos_capabilities_1.WebOSCapabilities();
                        networkStatus = new webos_network_status_1.WebOSNetworkStatus(this.context);
                        return [4, deviceInfo.load()];
                    case 1:
                        _a.sent();
                        player = new webos_player_1.WebOSPlayer(this.context, drmAgent, this.startingBitrate, deviceInfo.isWebOS2());
                        return [4, player.initialise()];
                    case 2:
                        _a.sent();
                        this.device = {
                            player: player,
                            input: input,
                            deviceInfo: deviceInfo,
                            lifecycle: lifecycle,
                            storage: storage,
                            capabilities: capabilities,
                            networkStatus: networkStatus,
                        };
                        this.initialised = true;
                        return [2];
                }
            });
        });
    };
    return WebOSDeviceFactory;
}());
exports.WebOSDeviceFactory = WebOSDeviceFactory;
